import { Deserializable } from '../deserializable';

export class LinkedCaseDetailsDto implements Deserializable {
  public CaseNumber: number;
  public CaseNumberAsHash: string;
  public CustomerName: string;
  public CaseStatus: string;
  public CaseOwner: string;
  public CompanyName: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
